import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import React from 'react';
import Formatter from '../../../formatter';

var addExpression = function addExpression(userFilter, field, value, op) {
  userFilter.Expressions.push({
    Field: field,
    Value: value,
    Op: op || 'equal'
  });
};

var addTagsFilters = function addTagsFilters(userFilter, dataProps) {
  var tags = dataProps.tags,
      filter = dataProps.filter;
  if (!tags) return;
  if (filter.filterBy === 'ContractState') tags = [].concat(_toConsumableArray(tags), [{
    field: 'ContractState',
    value: filter.filterValue
  }]);
  tags.map(function (tag) {
    addExpression(userFilter, 'Tag_' + (tag.field ? tag.field : tag), tag.value ? tag.value : 'true', 'equal');
  });
};

var addJobStageFilter = function addJobStageFilter(userFilter, jobStage, filter) {
  if (!jobStage && filter.filterBy != 'jobStage') return;
  jobStage = jobStage || filter.filterValue;
  addExpression(userFilter, 'jobStage', jobStage, filter.filterOperator);
};

var addJobTypeFilter = function addJobTypeFilter(userFilter, jobType, filter) {
  if (!jobType && filter.filterBy != 'jobType') return;
  jobType = jobType || filter.filterValue;
  addExpression(userFilter, 'JobType', jobType, filter.filterOperator);
};

var addSearchByFilter = function addSearchByFilter(userFilter, filter) {
  if (!filter || !filter.searchIn) return;
  var searchIn = filter.searchIn,
      searchValue = filter.searchValue,
      searchOperator = filter.searchOperator;
  addExpression(userFilter, searchIn, searchValue, searchOperator);
};

var createUserFilter = function createUserFilter(dataProps, queryFilter) {
  var userFilter = {
    Expressions: []
  };
  addTagsFilters(userFilter, dataProps);

  if (dataProps.jobStage || dataProps.filter.filterBy === 'jobStage') {
    addExpression(userFilter, 'JobType', 'Workflow4', dataProps.filter.filterOperator);
    addJobStageFilter(userFilter, dataProps.jobStage, dataProps.filter);
  } else if (dataProps.filter.filterBy === 'jobType') addJobTypeFilter(userFilter, dataProps.jobType, dataProps.filter);else if (!dataProps.showTestLetters) addExpression(userFilter, 'JobType', 'Workflow4', dataProps.filter.filterOperator);

  addSearchByFilter(userFilter, dataProps.filter);
  addSearchByFilter(userFilter, queryFilter);
  return JSON.stringify(userFilter);
};

var NameFormatter = function NameFormatter(_ref) {
  var data = _ref.data;
  return React.createElement(Formatter.Text, {
    value: data.JobName
  });
};

var StatusFormatter = function StatusFormatter(_ref2) {
  var data = _ref2.data;
  return React.createElement(Formatter.JobStatus, {
    value: data.Stage
  });
};

var LastModifiedFormatter = function LastModifiedFormatter(_ref3) {
  var data = _ref3.data;
  return React.createElement(Formatter.DateTime, {
    value: data.LastModified
  });
};

var StartDateFormatter = function StartDateFormatter(_ref4) {
  var data = _ref4.data;
  return React.createElement(Formatter.DateTime, {
    value: data.StartDate
  });
};

var AuthorFormatter = function AuthorFormatter(_ref5) {
  var data = _ref5.data;
  return React.createElement(Formatter.Text, {
    value: data.Author
  });
};
/**
 * @typedef { object } CommunicationBasicModel Data model returned by the sever representing a communication job.
 * @property { string } JobName Job name
 * @property { string } Id Job identifier
 * @property { string } Communication Project name
 * @property { string } Author Job author
 * @property { string } Stage Job stage (Aborted | Processing | FinishedWithErrors | FinishedOK | Starting | WaitingForInput | WaitingForTask | WaitingForSignature)
 * @property { string } Workspace Project workspace.
 * @property { string } LastModified Last modified date.
 **/

/** @type {import('../types').DataType<CommunicationBasicModel>} */


var COMMUNICATION_DATA_TYPE = {
  data: {
    url: '/backend/communicationRun?',
    itemUrl: '/backend/jobs?id={id}',
    dataKey: 'communications',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView' && options.dataProps) {
        var userFilters = null;
        var query = request.query;

        if (query && query.Filter && query.Filter.length) {
          var queryFilter = {
            searchIn: query.SortField,
            searchValue: query.Filter
          };
          userFilters = createUserFilter(options.dataProps, queryFilter);
        } else {
          userFilters = createUserFilter(options.dataProps);
        }

        var includeOrphansJobs = options.dataProps.includeOrphansJobs;
        return _objectSpread({}, request, {
          query: _objectSpread({}, request.query, {
            viewId: -1,
            userFilters: userFilters,
            includeOrphansJobs: includeOrphansJobs || false
          })
        });
      }

      if (request.type === 'loadItem' && options.dataProps) {
        return _objectSpread({}, request, {
          query: _objectSpread({}, request.query, {
            workspace: options.dataProps.workspace
          })
        });
      }

      if (request.type === 'deleteItem' && options.workspace) {
        return _objectSpread({}, request, {
          query: _objectSpread({}, request.query, {
            workspace: options.workspace
          })
        });
      }

      return request;
    }
  },
  placeholders: {
    label: function label(data) {
      return data.JobName;
    },
    type: function type() {
      return 'communication';
    },
    icon: function icon() {
      return 'communication';
    },
    contactSynchronizationId: function contactSynchronizationId(data) {
      return data.Parameters.find(function (p) {
        return p.Name === 'ContactId';
      }).Value;
    },
    projectId: function projectId(data) {
      return data.Parameters.find(function (p) {
        return p.Name === 'CommunicationId';
      }).Value;
    }
  },
  columns: [{
    id: 'Communication',
    children: 'Name',
    formatter: NameFormatter
  }, {
    id: 'Status',
    children: 'Status',
    formatter: StatusFormatter
  }, {
    id: 'Author',
    children: 'Author',
    formatter: AuthorFormatter
  }, {
    id: 'StartDateUTC',
    children: 'Start Date',
    formatter: StartDateFormatter
  }, {
    id: 'LastModifiedUTC',
    children: 'Last Modified',
    formatter: LastModifiedFormatter
  }]
};
export default COMMUNICATION_DATA_TYPE;